import { GAME_VARIABLES } from "../../../constants";

export class Chunk2 {
  private particles: Phaser.GameObjects.Particles.ParticleEmitterManager;
  constructor(scene: Phaser.Scene) {
    this.particles = scene.add.particles("atlas");
    scene.cameras.main.setBackgroundColor(0x3f3347);
    var emitZone = new Phaser.Geom.Rectangle(-8, -8, 128 + 8, 128 + 8);
    var emitter = this.particles.createEmitter({
      frame: Array.from(new Array(9)).map((_, i) => `FX/Clouds/Cloud${i + 1}`),
      speed: { min: 0.1, max: 1 },
      lifespan: { min: 15000, max: 30000 },
      frequency: 1,
      quantity: { min: 1, max: 3 },
      scale: { min: 0.8, max: 0.5 },
      blendMode: "SCREEN",
      emitZone: { source: emitZone },
    });
    emitter.setAlpha(function (
      p: Phaser.GameObjects.Particles.Particle,
      _k: number,
      t: number
    ) {
      return 1 - 2 * Math.abs(t - 0.5);
    });
    scene.time.delayedCall(80, () => {
      emitter.setFrequency(2400);
    });
    this.particles.setDepth(-1.98);

    const sprite1 = scene.add.sprite(
      0,
      GAME_VARIABLES.IS_RESTART ? 0 : -30,
      "atlas",
      "background/back_background"
    );
    const sprite2 = scene.add.sprite(
      0,
      GAME_VARIABLES.IS_RESTART ? 0 : -10,
      "atlas",
      "background/front_background"
    );

    if (!GAME_VARIABLES.IS_RESTART) {
      scene.add.tween({
        targets: sprite1,
        y: `+=30`,
        duration: 3000,
        ease: "Expo.easeOut",
      });
      scene.add.tween({
        targets: sprite2,
        y: `+=10`,
        duration: 3000,
        ease: "Expo.easeOut",
      });
    }
    const sprite_fog1 = scene.add.sprite(
      0,
      5 * 8 + 4,
      "atlas",
      "background/fog"
    );
    const sprite_fog2 = scene.add.sprite(0, 11 * 8, "atlas", "background/fog");

    sprite1.setDepth(-2);
    sprite_fog1.setDepth(-1.95);
    sprite2.setDepth(-1.9);
    sprite_fog2.setDepth(-1.85);

    sprite1.setActive(false);
    sprite2.setActive(false);
    sprite_fog1.setActive(false);
    sprite_fog2.setActive(false);

    scene.add.tween({
      targets: sprite_fog1,
      duration: 10000,
      repeat: -1,
      ease: "Sine.easeInOut",
      y: "+=16",
      yoyo: true,
    });
    scene.add.tween({
      targets: sprite_fog2,
      duration: 10000,
      repeat: -1,
      delay: Math.random() * 4000 + 2000,
      ease: "Sine.easeInOut",
      y: "+=16",
      yoyo: true,
    });
  }
}
